/**
 * Entry point for BModal module.
 * We bind directives, utils, etc, to the module here
 */
const showBModal = async (modalTarget, data, context) => {
  context.$root.$emit("modal-bind-data", modalTarget, data);
  await context.$nextTick();
  //eslint-disable-next-line vue/custom-event-name-casing
  context.$root.$emit("bv::show::modal", modalTarget);
};
export { showBModal };